export const initialEfakturaSharingState = {
    name: undefined,
    ssn: undefined,
    selected: undefined,
    amountSelected: undefined,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvd2lkZ2V0cy9FZmFrdHVyYVNoYXJpbmcvZm9ybS9zdGF0ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXQSxNQUFNLENBQUMsTUFBTSwyQkFBMkIsR0FBeUI7SUFDN0QsSUFBSSxFQUFFLFNBQVM7SUFDZixHQUFHLEVBQUUsU0FBUztJQUNkLFFBQVEsRUFBRSxTQUFTO0lBQ25CLGNBQWMsRUFBRSxTQUFTO0NBQzVCLENBQUMifQ==